import { useContext } from 'react'
import Context from '../Context'
// Antd
import { Button, Modal as AntdModal } from 'antd'
import UpdateUserInfo from './Children/UpdateUserInfo'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

const Modal: React.FC = () => {
  const { t } = useTranslation()
  const {
    states: { open },
    actions: { onClose }
  } = useContext(Context)

  const props = {
    open,
    footer: [],
    width: 500,
    title: t('UPDATE_USER_INFO'),
    onCancel: onClose,
    children: <UpdateUserInfo />,
    className: styles.modal
  }

  return <AntdModal {...props} />
}

export default Modal
